<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-funnel-control p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração Funnel Control
        </strong>
      </div>
      <div class="d-flex align-items-center mb-5">
        <small class="text-dark flex-fill mt-5">
          <a
            target="_blank"
            href="https://funnelcontrol.online/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça a Funnel Control
          </a>
        </small>
      </div>
      <hr />

      <div class="my-5">
        <div class="d-flex justify-content-center" v-if="!form.token">
          <b-spinner variant="primary" />
        </div>

        <div v-else>
          <small>Token da integração</small>
          <div
            class="form-control d-flex align-items-center justify-content-between"
          >
            <span class="ellipsis">
              {{ form.token }}
            </span>
            <button class="btn btn-sm text-primary" @click="copyToken">
              <i class="icon-copy" />
            </button>
          </div>

          <span class="form-description">
            Esse token será usado para gerar a URL da sua integração na
            plataforma.
          </span>
        </div>
        <hr />
      </div>

      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <form-group
          :disabled="form.id != null"
          slim
          select
          id="product-select"
          label="Nome do produto"
          v-model="form.product_id"
          :errors="errors.product_id"
          placeholder="Selecionar produto..."
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <form-group
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
        :errors="errors.description"
        placeholder="Digite a descrição da integração..."
      />
      <form-group
        label="URL"
        id="url"
        v-model="form.url"
        :errors="errors.url"
        placeholder="Digite a URL..."
      />

      <action-dispatcher action="integration/getTypeEvents">
        <form-group
          select
          multiple
          label="Eventos disparados"
          id="events-select"
          v-model="form.events"
          :errors="errors.events"
          placeholder="Selecionar eventos..."
          :options="typeEvents"
        />
      </action-dispatcher>
      <div class="d-flex justify-content-center pt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'bg-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        ["product_id", "url", "status", "description", "events", "name"],
        {
          events: [],
          name: "funnel_control",
          extras: { is_json: true }
        }
      ),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (v && !this.integrationToEdit) {
        this.$store
          .dispatch("integration/getFunnelControlToken")
          .then(this.setToken);
      }

      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
        this.form.events = v.events.map(e => e.event);
        this.form.product_id = v.events[0].product_id;
        this.form.extras = v.extras || { is_json: true };
      }
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["typeEvents"]),
    isValid() {
      return (
        this.form.events.length &&
        this.form.product_id &&
        this.form.url &&
        this.form.token
      );
    }
  },
  methods: {
    copyToken() {
      navigator.clipboard.writeText(this.form.token);
      this.$message.success("Token copiado");
    },
    setToken({ token }) {
      this.form.token = token;
    },
    clear() {
      this.form = {
        name: "funnel_control",
        events: [],
        extras: { is_json: true }
      };
      this.$emit("clear-edit");
    },
    submit() {
      if (this.loading) return;

      this.loading = true;
      let data = { ...this.form };
      data.events = data.events.map(e => {
        return { event: e };
      });
      let action = "integration/postIntegration";
      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.loading = false;
          this.visible = false;
          this.$emit("update-list");
          this.clear();
          this.$message.success("A integração foi salva!");
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar configuração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-funnel-control {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
  .ellipsis {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    word-wrap: break-word;
    white-space: pre;
  }
}
</style>
